import { useParams } from "react-router-dom";
import { blogs } from "../../data/blogs";
import { Helmet } from "react-helmet-async";
import "../../Components/BlogDetail/index.css";

const BlogDetail = () => {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);
  const getImage = (filename: string) => {
    return require(`../../assets/images/${filename}`);
  };

  const renderContent = (content: any[]) => {
    return content.map((block, index) => {
      switch (block.type) {
        case "heading":
          if (block.level === 1)
            return (
              <h1 key={index} style={{ textDecoration: "underline" }}>
                {block.text}
              </h1>
            );
          if (block.level === 2) return <h4 key={index}>{block.text}</h4>;
          if (block.level === 3)
            return (
              <h4 key={index} style={{ textDecoration: "underline" }}>
                {block.text}
              </h4>
            );
          return <h3 key={index}>{block.text}</h3>;

        case "paragraph":
          return (
            <p key={index}>
              {block.parts.map((part: any, i: number) => {
                if (part.type === "text") return <span dangerouslySetInnerHTML={{ __html: part.text }} />;
                if (part.type === "link")
                  return (
                    <a
                      key={i}
                      href={part.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {part.text}
                    </a>
                  );
                return null;
              })}
            </p>
          );

        case "list":
          return (
            <ul key={index}>
              {block.items.map((item: any, i: number) => (
                <li key={i}>
                  {typeof item === "string" ? (
                    item
                  ) : (
                    <>
                      <strong>{item.label}: </strong>
                      <span dangerouslySetInnerHTML={{ __html: item.text }} />
                    </>
                  )}
                </li>
              ))}
            </ul>
          );

        case "imageRow":
          return (
            <div className="image-row" key={index}>
              {block.images.slice(0, 4).map((filename: string, i: number) => (
                <img
                  key={i}
                  src={getImage(filename)}
                  alt={`Blog graphic ${i + 1}`}
                />
              ))}
            </div>
          );

          case "html":
            return (
              <div dangerouslySetInnerHTML={{ __html: block.text }} />
          );

        default:
          return null;
      }
    });
  };

  if (!blog) return <p>Blog not found.</p>;

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>{blog.title}</title>
        <meta property="og:title" content={blog.metatitle} />
        <meta property="og:description" content={blog.description} />
        <meta name="description" content={blog.description} />
        <meta name="keywords" content={blog.keywords} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": blog.title,
            "description": blog.description,
            "image": `${window.location.origin}${getImage(blog.coverImage).replace(/^\./, "")}`,
            "author": {
              "@type": "Person",
              "name": "SkyAzul",
              "url": "https://www.skyazul.com/"
            },
            "publisher": {
              "@type": "Organization",
              "name": "SkyAzul",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.skyazul.com/static/media/companylogo.1b52821c723f36d1c034.png"
              }
            },
            "datePublished": blog.publishedAt
          })}
        </script>
      </Helmet>
      <div className="container py-5">
        <h1>{blog.title}</h1>
        <p className="text-muted">Published on {blog.publishedAt}</p>
        <div className="blog-image-wrapper">
          <img
            src={getImage(blog.coverImage)}
            className="img-fluid mb-4"
            alt={blog.title}
          />
        </div>
        <div className="blog-content">
          {renderContent(blog.content)}
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
